module.exports = __webpack_public_path__ + "static/IBMPlexSerif-Regular-bfc0c1efd48c7e6dcbd2504c849a3a51.ttf";